import { NodeStatus, Status } from "../types";
import type { AddressProviderTreeNode, ScrapingAddressData, ScrapingProviderData } from "../types";

const RESOLVED_STATUSES: Status[] = [Status.COMPLETED, Status.PAID, Status.PROCESSING, Status.SKIPPED, Status.PENDING];

const getNodeStatus = (logStatus: string): NodeStatus => {
  if (logStatus === Status.FAILED) return NodeStatus.ERROR;
  if (RESOLVED_STATUSES.includes(logStatus as Status)) return NodeStatus.SUCCESS;
  return NodeStatus.LOADING;
};

const buildAddressStatus = (providers: ScrapingProviderData[]): NodeStatus => {
  const hasLoading = providers.some((p) => p.status === NodeStatus.LOADING);
  const errorCount = providers.filter((p) => p.status === NodeStatus.ERROR).length;

  if (hasLoading) return NodeStatus.LOADING;
  if (errorCount === providers.length) return NodeStatus.ERROR;
  if (errorCount > 0) return NodeStatus.WARN;
  return NodeStatus.SUCCESS;
};

const providerId = (addressName: string, providerName: string): string => `prov-${addressName}-${providerName}`;

const toProviderData = (
  addressName: string,
  prov: AddressProviderTreeNode["providers"][number],
  providerStates: Map<string, NodeStatus>,
): ScrapingProviderData => {
  const id = providerId(addressName, prov.name);
  return { id, name: prov.name, status: providerStates.get(id) ?? NodeStatus.LOADING };
};

const buildAddress = (addr: AddressProviderTreeNode, providerStates: Map<string, NodeStatus>): ScrapingAddressData => {
  const providers = addr.providers.map((prov) => toProviderData(addr.addressName, prov, providerStates));
  return { addressName: addr.addressName, status: buildAddressStatus(providers), providers };
};

const buildScrapingTree = (initialAddresses: AddressProviderTreeNode[], providerStates: Map<string, NodeStatus>): ScrapingAddressData[] =>
  initialAddresses.map((addr) => buildAddress(addr, providerStates));

export { getNodeStatus, buildScrapingTree };
